import React from "react"
import styled from "styled-components"

/*
  Use cases:
  Icon only 
  <WebinarButton 
    icon={<InstagramIcon />} 
    bg="#000" hover="#444" 
    border="1px solid #ddd" 
    width="5rem"
     height="5rem"
  ><InstagramIcon /></WebinarButton>

  Text only
  <WebinarButton>Join Room</WebinarButton>

  Icon and text
  <WebinarButton><InstagramIcon />Join Room</WebinarButton>
*/

const Button = styled.button`
  width: ${({ width }) => width};
  height: ${({ height }) => height};
  min-height: ${({ height }) => !height && "4rem"};
  padding: 0.8rem 1.6rem;
  background-color: ${({ disabled, bg, backgroundColor, theme }) =>
    (disabled && theme.colors.webinar.button.disabled) ||
    bg ||
    backgroundColor ||
    theme.colors.webinar.button.primary};
  color: ${({ color, theme }) => color || theme.colors.webinar.button.primaryText};
  border: ${({ border }) => border || "none"};
  border-radius: 0.8rem;
  font-family: "Inter", sans-serif;
  font-size: ${({ fontSize }) => fontSize || "1.6rem"};
  font-weight: ${({ fontWeight }) => fontWeight || "500"};
  line-height: ${({ lineHeight }) => lineHeight || "2.4rem"};
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: row;
  gap: 0.8rem;
  cursor: ${({ disabled }) => (disabled ? "not-allowed" : "pointer")};
  ${(props) => props.css}

  &:hover {
    background-color: ${({ disabled, hover, theme }) =>
      (disabled && theme.colors.webinar.button.disabled) ||
      hover ||
      theme.colors.webinar.button.primaryHover};
  }
`

export const WebinarButton = ({ children = null, ...props }) => (
  <Button {...props}>{children}</Button>
)
